export * from './map-facade.service';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/map-facade/services/index.ts